import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function fetchConversations(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DC_CONVERSATIONS_FETCH,
    (organisationId, projectId, matterId, documentId, issueId) =>
      requestor
        .get(
          `${basePath}/organisation/${organisationId}` +
            `/project/${projectId}` +
            `/matter/${matterId}` +
            `/document/${documentId}` +
            `/conversation${issueId ? `?issue_id=${issueId}` : ""}`,
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
